import React, { useState } from "react";

export default function LoginPage() {
  const apiBase = process.env.REACT_APP_API_URL || "/api";
  const loginUrl = apiBase + "/auth/login";

  const [debug, setDebug] = useState(null);
  const [loading, setLoading] = useState(false);

  const urlParams = new URLSearchParams(window.location.search);
  const errorParam = urlParams.get("error");

  const runDebug = async () => {
    setLoading(true);
    const info = {
      "1_apiBase": apiBase,
      "2_browserCookies": document.cookie || "(keine Cookies im Browser sichtbar)",
      "3_currentUrl": window.location.href,
    };

    try {
      const r = await fetch(apiBase + "/auth/debug-session", { credentials: "include" });
      info["4_debugSession"] = await r.json();
    } catch (e) {
      info["4_debugSession"] = "FETCH FEHLER: " + e.message;
    }

    try {
      const r2 = await fetch(apiBase + "/auth/me", { credentials: "include" });
      info["5_meStatus"] = r2.status;
      info["5_meBody"] = await r2.json();
    } catch (e) {
      info["5_meStatus"] = "FETCH FEHLER: " + e.message;
    }

    setDebug(info);
    setLoading(false);
  };

  const testCookie = async () => {
    try {
      const r = await fetch(apiBase + "/auth/test-cookie", { credentials: "include" });
      const data = await r.json();
      alert("Server-Antwort:\n" + JSON.stringify(data, null, 2) +
            "\n\nBrowser-Cookies danach:\n" + (document.cookie || "(keine)"));
    } catch(e) {
      alert("Fehler: " + e.message);
    }
  };

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center",
      justifyContent: "center", flexDirection: "column",
      background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)",
      padding: 24,
    }}>
      <div style={{
        background: "white", borderRadius: 12, padding: "48px 40px",
        boxShadow: "0 20px 60px rgba(0,0,0,0.3)", textAlign: "center",
        maxWidth: 460, width: "100%"
      }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>🏢</div>
        <h1 style={{ fontSize: 24, fontWeight: 700, color: "#1a1a2e", marginBottom: 8 }}>
          Mitarbeiter Verwaltung
        </h1>
        <p style={{ color: "#666", fontSize: 14, marginBottom: 32 }}>
          freestyle · Internes Admin-Tool
        </p>

        {errorParam && (
          <div style={{ background: "#fff0f0", border: "1px solid #ffaaaa", borderRadius: 6,
            padding: "10px 14px", marginBottom: 20, fontSize: 13, color: "#c00" }}>
            ⚠️ Fehler-Code: <strong>{errorParam}</strong>
          </div>
        )}

        <a
          href={loginUrl}
          style={{
            display: "flex", alignItems: "center", justifyContent: "center", gap: 12,
            background: "#0078d4", color: "white", padding: "14px 24px",
            borderRadius: 8, textDecoration: "none", fontWeight: 600, fontSize: 15,
            transition: "background 0.2s",
          }}
          onMouseOver={(e) => e.currentTarget.style.background = "#005a9e"}
          onMouseOut={(e) => e.currentTarget.style.background = "#0078d4"}
        >
          <svg width="20" height="20" viewBox="0 0 21 21" fill="none">
            <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
            <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
            <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
            <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
          </svg>
          Mit Microsoft anmelden
        </a>

        <p style={{ marginTop: 24, fontSize: 12, color: "#999" }}>
          Nur für autorisierte Administratoren
        </p>

        {/* Debug-Panel */}
        <div style={{ marginTop: 28, borderTop: "1px solid #eee", paddingTop: 16 }}>
          <p style={{ fontSize: 11, color: "#bbb", marginBottom: 10 }}>— Debug —</p>
          <div style={{ display: "flex", gap: 8, justifyContent: "center", flexWrap: "wrap" }}>
            <button onClick={runDebug} disabled={loading} style={{
              fontSize: 11, padding: "6px 14px", background: "#f5f5f5",
              border: "1px solid #ddd", borderRadius: 4, cursor: "pointer"
            }}>
              {loading ? "Lädt..." : "🔍 Session-Info abrufen"}
            </button>
            <button onClick={testCookie} style={{
              fontSize: 11, padding: "6px 14px", background: "#f5f5f5",
              border: "1px solid #ddd", borderRadius: 4, cursor: "pointer"
            }}>
              🍪 Cookie-Test
            </button>
          </div>

          {debug && (
            <pre style={{
              marginTop: 12, textAlign: "left", fontSize: 10.5, background: "#111",
              color: "#0f0", padding: 12, borderRadius: 6, overflow: "auto",
              maxHeight: 350, whiteSpace: "pre-wrap", wordBreak: "break-all",
              lineHeight: 1.5,
            }}>
              {JSON.stringify(debug, null, 2)}
            </pre>
          )}
        </div>
      </div>
    </div>
  );
}
